import React from 'react';
import { Box, Grid } from '@mui/material';
import DocumentUpload from '../components/Documents/DocumentUpload';
import DocumentList from '../components/Documents/DocumentList';

const DocumentsPage = () => {
  return (
    <Box>
      <Grid container spacing={3}>
        <Grid item xs={12} md={6}>
          <DocumentUpload />
        </Grid>
        <Grid item xs={12} md={6}>
          <DocumentList />
        </Grid>
      </Grid>
    </Box>
  );
};

export default DocumentsPage;
